import React from "react";
import {
  Nav,
  Card,
  BarChart,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Pagination,
  FormInput,
  FormSelectMultiples,
  Loader,
  TabsCustom,
  TabsCustomBody,
  TabsCustomHeader,
  TabsCustomItem,
  TabsCustomMenu,
  ButtonIcon,
} from "ui-kit-ck-consultant";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";
import ModalAnomalyParams from "../../../components/precisia/ModalAnomalyParams";

import anomalyDescriptions from "../../../utils/anomalyDescriptions";

import axiosConfig from "../../../utils/axiosConfig";
import filterStore from "../../../stores/filterStore";

import { colors, getColors } from "../../../utils/colors";

import natureExpertise from "../../../utils/natureExpertise";

import { getCurrencyValue } from "../../../utils/general";

import { Row, Col } from "react-flexbox-grid";

import handleSortClick from "../../../utils/handleSortClick";

import moment from "moment";

import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
  faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Indicator options come from the static anomaly dictionary so they can be
// selected before any NGRA filter (and before any data is loaded).
const INDICATOR_OPTIONS = Object.keys(anomalyDescriptions)
  .sort((a, b) => a.localeCompare(b))
  .map((label) => ({ text: label, value: label }));

const EMPTY_DATA = {
  dates: [],
  dataDay: [],
  dataVisitDay: [],
  dataMonth: [],
  dataYear: [],
  dataTypeMonth: [],
  dataTypeYear: [],
  dataVisitMonth: [],
  dataVisitYear: [],
  dataTypeDay: {},
  folders: [],
  countVisit: 0,
  countAlert: 0,
  noResultMessage: false,
};

export default class PrecisiaPilotage extends React.Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("precisiaPilotage");
    this.state = saved || {
      isLoad: false,
      indicatorMultiples: [],
      searchReference: "",
      network: null,
      group: null,
      region: null,
      agency: null,
      expert: null,
      company: null,
      tabsIndex: 0,
      tabsMenu: ["Indicateurs expert", "Indicateurs assistant(e)"],
      expertData: { ...EMPTY_DATA },
      assistantData: { ...EMPTY_DATA },
      // PAGINATION
      activePage: 1,
      pageLength: 100,
      tabLength: 20,
      total: 0,
      order: {
        name: "reference",
        desc: true,
      },
      modalParamsShow: false,
      modalParamsFolder: null,
    };
    this.sortRef = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];
  }

  componentDidMount() {
    if (this.state.modalParamsShow) {
      this.setState({ modalParamsShow: false, modalParamsFolder: null });
    }
  }

  componentWillUnmount() {
    filterStore.getState().setPageState("precisiaPilotage", this.state);
  }

  handleSortClick = (desc, column) => {
    this.setState({ order: handleSortClick(this.sortRef, desc, column) });
  };

  getTabDataKey() {
    return this.state.tabsIndex === 0 ? "expertData" : "assistantData";
  }

  getTabData() {
    return this.state.tabsIndex === 0
      ? this.state.expertData
      : this.state.assistantData;
  }

  getDataPrecisiaPilotage() {
    const dataKey = this.getTabDataKey();
    this.setState({ isLoad: true }, () => {
      axiosConfig("alert/get-data-precisia-pilotage", {
        data: {
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          expert: this.state.expert,
          company: this.state.company,
          type: this.state.tabsIndex === 0 ? 1 : 2,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              [dataKey]: {
                dates: res.data.dates,
                dataDay: res.data.dataDay,
                dataVisitDay: res.data.dataVisitDay,
                dataMonth: res.data.dataMonth,
                dataYear: res.data.dataYear,
                dataTypeMonth: res.data.dataTypeMonth || [],
                dataTypeYear: res.data.dataTypeYear || [],
                dataVisitMonth: res.data.dataVisitMonth,
                dataVisitYear: res.data.dataVisitYear,
                dataTypeDay: res.data.dataTypeDay,
                folders: res.data.folders,
                countVisit: res.data.countVisit,
                countAlert: res.data.countAlert,
                noResultMessage: res.data.folders.length === 0,
              },
              isLoad: false,
            });
          } else {
            this.setState(
              {
                [dataKey]: { ...EMPTY_DATA },
                isLoad: false,
              },
              () => {
                alert("Une erreur est survenue");
              },
            );
          }
        })
        .catch(() => {
          this.setState(
            {
              [dataKey]: { ...EMPTY_DATA },
              isLoad: false,
            },
            () => {
              alert("Une erreur est survenue");
            },
          );
        });
    });
  }

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("precisiaPilotage", data);
    this.setState(
      {
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        expert: data.user,
        company: data.company,
      },
      () => {
        this.getDataPrecisiaPilotage();
      },
    );
  };

  onTabChange = (idx) => {
    const dataKey = idx === 0 ? "expertData" : "assistantData";
    this.setState({ tabsIndex: idx, activePage: 1 }, () => {
      if (this.state[dataKey].dates.length === 0 && this.state.region) {
        this.getDataPrecisiaPilotage();
      }
    });
  };

  renderChartsAndTable() {
    const tabData = this.getTabData();
    const {
      dates,
      dataVisitDay,
      dataVisitMonth,
      dataVisitYear,
    } = tabData;
    const hasIndicatorFilter = this.state.indicatorMultiples.length > 0;
    const isSelectedIndicator = (label) =>
      !hasIndicatorFilter || this.state.indicatorMultiples.includes(label);

    const dataTypeDay = Object.keys(tabData.dataTypeDay).reduce((acc, key) => {
      if (isSelectedIndicator(key)) acc[key] = tabData.dataTypeDay[key];
      return acc;
    }, {});

    const dataDay = hasIndicatorFilter
      ? (dates || []).map((_, idx) =>
          Object.values(dataTypeDay).reduce(
            (sum, series) => sum + (series[idx] || 0),
            0,
          ),
        )
      : tabData.dataDay;

    const aggregateByPeriod = (rows, keyFn, sortFn) => {
      const map = new Map();
      rows.filter((r) => isSelectedIndicator(r.label)).forEach((r) => {
        const k = keyFn(r);
        const prev = map.get(k) || { ...r, count: 0, total: 0 };
        prev.count += Number(r.count) || 0;
        prev.total += Number(r.total) || 0;
        map.set(k, prev);
      });
      return [...map.values()].sort(sortFn);
    };

    const dataMonth = hasIndicatorFilter
      ? aggregateByPeriod(
          tabData.dataTypeMonth,
          (r) => `${r.year}-${r.month}`,
          (a, b) => a.year - b.year || a.month - b.month,
        )
      : tabData.dataMonth;
    const dataYear = hasIndicatorFilter
      ? aggregateByPeriod(
          tabData.dataTypeYear,
          (r) => `${r.year}`,
          (a, b) => a.year - b.year,
        )
      : tabData.dataYear;
    const colorsArray = getColors();
    const visitLabel =
      this.state.tabsIndex === 1 ? "Nb missions" : "Nb visites";
    const theadData = [
      { key: "reference", label: "Référence" },
      { key: "label", label: "Indicateur" },
      { key: "regionName", label: "Région" },
      { key: "agencyName", label: "Agence" },
      { key: "expertName", label: "Expert" },
      { key: "assistantName", label: "Assistant(e)" },
      { key: "companyName", label: "Compagnie" },
      { key: "builder", label: "Marque" },
      { key: "model", label: "Modèle" },
      { key: "natureExpertise", label: "Nature d'expertise" },
      { key: "totalReportDutyFree", label: "Coût réparation HT" },
      { key: "VRADEDutyDree", label: "VRADE HT" },
      { key: "missionDate", label: "Date mission" },
      { key: "EADDate", label: "Date EAD" },
      { key: "visitDate", label: "Date visite avant travaux" },
      { key: "closingDate", label: "Date de cloture" },
    ];

    const folders = [...tabData.folders].sort((a, b) => {
      let aX = a[this.state.order.name] || "";
      let bX = b[this.state.order.name] || "";

      // Date sort
      if (moment(aX, "DD/MM/YYYY").isValid()) {
        const aXDate = moment(aX, "DD/MM/YYYY");
        const bXDate = moment(bX, "DD/MM/YYYY");

        return this.state.order.desc
          ? bXDate.format("YYYYMMDD") - aXDate.format("YYYYMMDD")
          : aXDate.format("YYYYMMDD") - bXDate.format("YYYYMMDD");
      }

      if (typeof aX == "number" && typeof bX == "number") {
        return this.state.order.desc ? aX - bX : bX - aX;
      } else {
        aX = aX.toString();
        bX = bX.toString();
        return this.state.order.desc
          ? aX.normalize().localeCompare(bX.normalize())
          : bX.normalize().localeCompare(aX.normalize());
      }
    });

    const searchReference = (this.state.searchReference || "")
      .trim()
      .toLowerCase();
    const filteredFolders = folders.filter(
      (folder) =>
        (this.state.indicatorMultiples.length > 0
          ? this.state.indicatorMultiples.includes(folder.label)
          : true) &&
        (searchReference
          ? (folder.reference || "")
              .toString()
              .toLowerCase()
              .includes(searchReference)
          : true),
    );

    return (
      <>
        {Object.keys(dataTypeDay).length > 0 && (
          <Card title="Tous les indicateurs" className={"mb-10 mb-30-xl"}>
            <BarChart
              title=""
              height={460}
              labels={dates}
              digits={0}
              dataSet={[
                {
                  label: "% indicateur / visite",
                  type: "line",
                  data: dataVisitDay.map((element, key) =>
                    element ? (dataDay[key] * 100) / element : 0,
                  ),
                  color: colors.red[0],
                  yAxisID: "A",
                },
                {
                  label: "Tous les indicateurs",
                  type: "bar",
                  data: dataDay,
                  color: colors.blue[0],
                  yAxisID: "B",
                },
                {
                  label: visitLabel,
                  type: "bar",
                  data: dataVisitDay,
                  color: colors.red[0],
                  yAxisID: "B",
                },
              ]}
              yAxes={[
                {
                  id: "A",
                  ticks: {},
                },
                {
                  id: "B",
                  ticks: {},
                },
              ]}
            />
          </Card>
        )}
        {Object.keys(dataTypeDay).length > 0 && (
          <Card title="Détails indicateurs" className={"mb-10 mb-30-xl"}>
            <BarChart
              isLegend
              title=""
              height={460}
              labels={dates}
              digits={0}
              dataSet={Object.keys(dataTypeDay).map((key, idx) => ({
                label: key,
                type: "line",
                data: dataTypeDay[key],
                color: colorsArray[idx],
              }))}
            />
          </Card>
        )}
        {Object.keys(dataMonth).length > 0 && (
          <Card
            title="Tous les indicateurs (moyenne jour / mois)"
            className={"mb-10 mb-30-xl"}
          >
            <BarChart
              title=""
              height={460}
              labels={dataMonth.map(
                (element) => `${element.month}/${element.year}`,
              )}
              dataSet={[
                {
                  label: "% indicateur / visite",
                  type: "line",
                  data: dataMonth.map((monthElement) => {
                    const visitElement = dataVisitMonth.find(
                      (v) =>
                        v.month === monthElement.month &&
                        v.year === monthElement.year,
                    );
                    return visitElement
                      ? (monthElement.total * 100) / visitElement.total
                      : 0;
                  }),
                  color: colors.red[0],
                  yAxisID: "A",
                },
                {
                  label: "Tous les indicateurs (moyenne jour / mois)",
                  type: "bar",
                  data: dataMonth.map((element) => element.count),
                  color: colors.blue[0],
                  yAxisID: "B",
                },
                {
                  label: visitLabel,
                  type: "bar",
                  data: dataMonth.map((monthElement) => {
                    const visitElement = dataVisitMonth.find(
                      (v) =>
                        v.month === monthElement.month &&
                        v.year === monthElement.year,
                    );
                    return visitElement ? visitElement.count : 0;
                  }),
                  color: colors.red[0],
                  yAxisID: "B",
                },
              ]}
              yAxes={[
                {
                  id: "A",
                  ticks: {},
                },
                {
                  id: "B",
                  ticks: {},
                },
              ]}
            />
          </Card>
        )}
        {Object.keys(dataYear).length > 0 && (
          <Card
            title="Tous les indicateurs (moyenne jour / an)"
            className={"mb-10 mb-30-xl"}
          >
            <BarChart
              title=""
              height={460}
              labels={dataYear.map((element) => element.year)}
              dataSet={[
                {
                  label: "% indicateur / visite",
                  type: "line",
                  data: dataYear.map((yearElement) => {
                    const visitElement = dataVisitYear.find(
                      (v) => v.year === yearElement.year,
                    );
                    return visitElement
                      ? (yearElement.total * 100) / visitElement.total
                      : 0;
                  }),
                  color: colors.red[0],
                  yAxisID: "A",
                },
                {
                  label: "Tous les indicateurs (moyenne jour / an)",
                  type: "bar",
                  data: dataYear.map((element) => element.count),
                  color: colors.blue[0],
                  yAxisID: "B",
                },
                {
                  label: visitLabel,
                  type: "bar",
                  data: dataYear.map((yearElement) => {
                    const visitElement = dataVisitYear.find(
                      (v) => v.year === yearElement.year,
                    );
                    return visitElement ? visitElement.count : 0;
                  }),
                  color: colors.red[0],
                  yAxisID: "B",
                },
              ]}
              yAxes={[
                {
                  id: "A",
                  ticks: {},
                },
                {
                  id: "B",
                  ticks: {},
                },
              ]}
            />
          </Card>
        )}
        {filteredFolders.length > 0 && (
          <Card title="Liste des dossiers" classNameChildren="overflow-x-auto">
            <Table
              isCSV
              getAllData={(callback) =>
                this.setState(
                  { pageLength: filteredFolders.length, activePage: 1 },
                  callback,
                )
              }
              csvCallback={() => this.setState({ pageLength: 100 })}
            >
              <Thead>
                <Tr>
                  <Th>#</Th>
                  {theadData.map((th, idx) => (
                    <Th
                      key={idx}
                      onSort={(desc) => this.handleSortClick(desc, idx)}
                      ref={this.sortRef[idx]}
                      sort
                      nameSort={th.key}
                    >
                      {th.label}
                    </Th>
                  ))}
                  <Th>Détails</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredFolders
                  .slice(
                    (this.state.activePage - 1) * this.state.pageLength,
                    this.state.activePage * this.state.pageLength,
                  )
                  .map((folder, idx) => (
                    <Tr key={idx}>
                      <Td>
                        {(this.state.activePage - 1) * this.state.pageLength +
                          idx +
                          1}
                      </Td>
                      <Td>{folder.reference}</Td>
                      <Td>{folder.label}</Td>
                      <Td>{folder.regionName}</Td>
                      <Td>{folder.agencyName}</Td>
                      <Td>{folder.expertName}</Td>
                      <Td>{folder.assistantName}</Td>
                      <Td>{folder.companyName}</Td>
                      <Td>{folder.builder}</Td>
                      <Td>{folder.model}</Td>
                      <Td>{natureExpertise(folder.natureExpertise)}</Td>
                      <Td>{getCurrencyValue(folder.totalReportDutyFree)}</Td>
                      <Td>{getCurrencyValue(folder.VRADEDutyDree)}</Td>
                      <Td>{folder.missionDate}</Td>
                      <Td>{folder.EADDate}</Td>
                      <Td>{folder.visitDate}</Td>
                      <Td>{folder.closingDate}</Td>
                      <Td>
                        <ButtonIcon
                          className="black"
                          small
                          onClick={() =>
                            this.setState({
                              modalParamsShow: true,
                              modalParamsFolder: folder,
                            })
                          }
                        >
                          <FontAwesomeIcon icon={faSearchPlus} />
                        </ButtonIcon>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.pageLength}
              totalItemsCount={filteredFolders.length}
              pageRangeDisplayed={4}
              onChange={(activePage) => {
                this.setState({ activePage: activePage });
              }}
              firstPageText={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
              lastPageText={<FontAwesomeIcon icon={faAngleDoubleRight} />}
              prevPageText={<FontAwesomeIcon icon={faChevronLeft} />}
              nextPageText={<FontAwesomeIcon icon={faChevronRight} />}
            />
          </Card>
        )}
        {tabData.noResultMessage && <Card>Aucun résultat</Card>}
        <ModalAnomalyParams
          show={this.state.modalParamsShow}
          folder={this.state.modalParamsFolder}
          onClose={() =>
            this.setState({ modalParamsShow: false, modalParamsFolder: null })
          }
        />
      </>
    );
  }

  render() {
    return (
      <>
        <Nav className="mb-10 mb-20-xl" title="PrécisIA Pilotage" />
        <ShowOptionsNGRA
          isChange={true}
          className="mb-10 mb-20-xl"
          onDataChange={this.handleDataChange}
          initialFilters={filterStore.getState().getPageFilters("precisiaPilotage")}
          visibilityRole={this.props.visibilityRole}
          visibilityType={this.props.visibilityType}
          preloadRole={this.props.preloadRole}
          preloadType={this.props.preloadType}
          limitUserType={this.props.limitUserType}
          limitUserRole={this.props.limitUserRole}
          isCompany={true}
          isUser={true}
          isAll={true}
          others={
            <Row>
              <Col xs={12} md={4} lg={2} className={"mb-10"}>
                <FormSelectMultiples
                  title="Indicateur(s)"
                  value={this.state.indicatorMultiples}
                  default="Tous les indicateurs"
                  options={INDICATOR_OPTIONS}
                  onChange={(value) =>
                    this.setState({
                      indicatorMultiples: [...value],
                      activePage: 1,
                    })
                  }
                />
              </Col>
              <Col xs={12} md={4} lg={2} className={"mb-10"}>
                <FormInput
                  title="Numéro de dossier"
                  placeholder="Rechercher un dossier"
                  value={this.state.searchReference}
                  name="searchReference"
                  onChange={({ target }) =>
                    this.setState({
                      searchReference: target.value,
                      activePage: 1,
                    })
                  }
                />
              </Col>
            </Row>
          }
        />

        <TabsCustom>
          <TabsCustomHeader>
            {this.state.tabsMenu.map((element, idx) => (
              <TabsCustomMenu
                key={idx}
                title={element}
                active={this.state.tabsIndex === idx}
                onClick={() => this.onTabChange(idx)}
              />
            ))}
          </TabsCustomHeader>
          <TabsCustomBody noCard>
            <TabsCustomItem active={this.state.tabsIndex === 0}>
              {this.state.tabsIndex === 0 && this.renderChartsAndTable()}
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsIndex === 1}>
              {this.state.tabsIndex === 1 && this.renderChartsAndTable()}
            </TabsCustomItem>
          </TabsCustomBody>
        </TabsCustom>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
